export default "__VITE_ASSET__J$4YkB2i__"